/*
 * @Author       : qixiao
 * @Date         : 2023-05-15 10:30:45
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-15 10:30:58
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\AgriculturalMonitoring\component\LandMapNq\js\bus.js
 * @Description  : 
 * 
 */
import Vue from 'vue';
 
export default new Vue;